import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-line bg-navy-950 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-144" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-145" data-mp="2vownos29qj4n">
        <div className="text-center" data-id="element-146" data-mp="39hma2xlplq2a">
          <SectionHeading id="problem-title" data-id="element-147" data-mp="39gkv4i1kojfa">Does This Sound <span className="text-fiber" data-id="element-148" data-mp="35gaqp9tfi12j">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-silver" data-id="element-149" data-mp="35g0x7c96dbs3">
            You work with fiber, cabling, radio or telecom equipment, or you want to grow into network roles, but the
            whole network feels like separate worlds. When someone talks about OTDR events, loss budgets, PON splits,
            Fresnel zones, sector antennas or NOC alarms, you can&apos;t connect all the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-line bg-navy-900 p-6 sm:p-8" data-id="element-150" data-mp="je6daslis85r">
          <p className="mb-5 inline-flex items-center gap-2 text-lg font-semibold text-white" data-id="element-151" data-mp="x62zkg0ibnu8">
            <AlertTriangleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-152" data-mp="123376vd08yng" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-153" data-mp="174sjeebyrid4">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-silver" data-id="element-154" data-mp="1c33rokmm1kt8">
                <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-fiber" aria-hidden="true" data-id="element-155" data-mp="1g22wm58cdhko" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-156" data-mp="3hu7ndde3u8tt">
          <p className="mx-auto max-w-2xl text-lg font-medium text-silver" data-id="element-157" data-mp="3hv0tcc58ouaw">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-2 text-2xl font-bold tracking-tight text-gold sm:text-3xl" data-id="element-158" data-mp="k1pc7isvziih">You need one organized system.</p>
        </div>
      </div>
    </section>;
}